import { render, staticRenderFns } from "./tabProductRelated.vue?vue&type=template&id=dd81b0f6&"
import script from "./tabProductRelated.vue?vue&type=script&lang=js&"
export * from "./tabProductRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports